import { CreateFlightBookingState } from './createFlightBooking.types'

const initialState: CreateFlightBookingState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
